module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/old/logoPink-902fc4b548641764aeaaca2fcbdcae2a.png";